import { Component, Inject, OnInit } from '@angular/core';
import { CereriService } from '../../cereri.service';
import {
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NotificationService } from 'src/app/services/notification.service';
import { ToastrService } from 'ngx-toastr';
import { FileData } from '../../cereri.interface';

@Component({
    selector: 'app-cerere-validare',
    templateUrl: './cerere-validare.component.html',
    styleUrls: ['./cerere-validare.component.scss'],
})
export class CerereValidareComponent implements OnInit {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;

    helper = helper;
    isAnexeLoading = false;
    isExemplarLoading = false;
    isLoading: boolean = false;

    validateDocumentForm!: FormGroup;

    uploading: any = {
        files_mesagerie_cetatean: false,
        files_mesagerie_intern: false,
        files_mesagerie_notita: false,
    };

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: { id: number; type: number, doc_type: number },
        private cereriService: CereriService,
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<CerereValidareComponent>,
        private notificationService: NotificationService,
        public toastr: ToastrService
    ) {
        console.log(this.data);
    }

    ngOnInit() {
        this.validateDocumentForm = this.fb.group({
            file: new FormControl(null, Validators.required),
            exemplarCetatean: new FormControl(null),
            anexe: this.fb.array([]),
        });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    removeFile() {
        this.validateDocumentForm.get('file')?.reset();
        const fileInput = document.getElementById(
            'upload-file-input-0'
        ) as HTMLInputElement;

        if (fileInput) {
            fileInput.value = '';
        }
    }

    addFile(event: any) {
        event.preventDefault();
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files || inputElement.files.length === 0) {
            return;
        }

        const file = inputElement.files[0];
        this.uploading.file = true;

        const formData = new FormData();
        formData.append('file', file, file.name);

        this.cereriService.fileUpload(formData).subscribe({
            next: (result: any) => {
                if (result && result.status_code === 200 && result.data) {
                    this.validateDocumentForm.get('file')?.setValue(result.data);

                    this.uploading.file = false;
                    this.openToast({
                        title: this.successTitle,
                        message: 'Fișierul dvs. a fost adăugat cu succes.',
                        type: this.successIcon,
                    });
                } else {
                    let errorMessage =
                        environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                    this.uploading.file = false;
                }
            },
            error: (error: any) => {
                this.isLoading = false;
                this.uploading.file = false;
                this.onHttpError(error);
            },
        });
    }

    addFileCetatean(event: any) {
        event.preventDefault();
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files || inputElement.files.length === 0) {
            return;
        }

        const file = inputElement.files[0];
        this.isExemplarLoading = true;

        const formData = new FormData();
        formData.append('exemplarCetatean', file, file.name);

        this.cereriService.fileUpload(formData).subscribe({
            next: (result: any) => {
                if (result && result.status_code === 200 && result.data) {
                    this.validateDocumentForm.get('exemplarCetatean')?.setValue(result.data);

                    this.isExemplarLoading = false;
                    this.openToast({
                        title: this.successTitle,
                        message: 'Fișierul dvs. a fost adăugat cu succes.',
                        type: this.successIcon,
                    });
                } else {
                    let errorMessage =
                        environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                    this.isExemplarLoading = false;
                }
            },
            error: (error: any) => {
                this.isLoading = false;
                this.isExemplarLoading = false;
                this.onHttpError(error);
            },
        });
    }

    submitDocumentSwitch() {
        if (this.data.type == 3) {
            // document official
            this.submitDocumentOficialSigned();
        } else {
            // document de validat
            this.submitDocumentValidare();
        }
    }

    submitDocumentValidare() {
        console.log(this.data.type);
        this.isLoading = true;
        console.log('document validare semnat final');

        const fileData = this.validateDocumentForm.get('file')?.value;
        const exemplarCetatean = this.validateDocumentForm.get('exemplarCetatean')?.value;

        const validateDoc = {
            files: [fileData],
            exemplarCetatean: [exemplarCetatean],
            type: this.data.type,
        };
        this.cereriService
            .validateDocument(this.data.id, this.data.type, validateDoc)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let errorMessage =
                        environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                },
            });
    }

    submitDocumentOficialSigned() {
        this.isLoading = true;


        const fileData = this.validateDocumentForm.get('file')?.value;
        const anexe = this.validateDocumentForm.get('anexe')?.value;
        const exemplarCetatean = this.validateDocumentForm.get('exemplarCetatean')?.value;
        const type = this.data.type;

        const validateDoc = {
            files: [fileData],
            anexe: anexe,
            exemplarCetatean: [exemplarCetatean],
            type: type,
        };
        this.cereriService
            .uploadFinalDocument(this.data.id, validateDoc)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let errorMessage =
                        environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                },
            });
    }

    onHttpError(res: any, showErrorsInToast: boolean = false) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                if (showErrorsInToast) {
                    this.openToast({
                        title: this.errorTitle,
                        message: msg,
                        type: this.errorType,
                    });
                } else {
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                }
            });
        } else {
            let errorMessage =
                environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
                this.errorTitle,
                errorMessage,
                this.errorIcon
            );
        }
    }

    openToast(object: any) {
        const { type, message, title } = object;

        let options = this.toastr.toastrConfig;
        options.progressBar = true;
        options.preventDuplicates = true;
        options.closeButton = true;

        const inserted = this.toastr.show(
            message,
            title,
            options,
            options.iconClasses[type]
        );
    }

    addFilesRegistru(event: any, key: 'registruFile') {
        event.preventDefault();
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            // Verifică dacă fișierul există deja în lista de fișiere încărcate
            const formFiles = this.validateDocumentForm.get('anexe')?.value;
            const fileExists = formFiles.some(
                (uploadedFile: FileData) => uploadedFile.original_name === file.name
            );

            if (fileExists) {
                this.openToast({
                    title: 'Atenție',
                    message: `Fișierul "${file.name}" este deja încărcat.`,
                    type: 'warning',
                });
                continue; // Sari peste acest fișier și continuă cu următorul
            }

            this.isAnexeLoading = true;

            const formData = new FormData();
            formData.append('registruFile', file, file.name);

            this.cereriService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== 'undefined' ? result : result.error;
                    if (typeof response.status_code !== 'undefined') {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== 'undefined'
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            const files = this.validateDocumentForm.get('anexe') as FormArray;
                            files.push(new FormControl(result.data));

                            this.isAnexeLoading = false;
                            this.openToast({
                                title: this.successTitle,
                                message:
                                    helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                type: this.successIcon,
                            });
                        }
                    } else {
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.isAnexeLoading = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.isAnexeLoading = false;
                    this.onHttpError(result.error);
                },
            });
        }

        // Reset the input value to allow re-uploading the same file
        inputElement.value = '';
    }

    removeFileRegistru(index: number) {
        const files = this.validateDocumentForm.get('anexe') as FormArray;
        if (index > -1 && index < files.length) {
            files.removeAt(index);
        }
    }
}
